<template>
  <div class="roleChannelUserMapping h100">
    <!-- <h1>This is an roleChannelUserMapping page</h1> -->
    <el-form :inline="true">
      <el-form-item label="选择系统角色">
        <el-select v-model="selectedId" placeholder="请选择系统角色">
          <el-option v-for="(items, index) in filterData" :key="index" :label="items.label" :value="items.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search()">搜 索</el-button>
      </el-form-item>
    </el-form>
    <!-- 角色渠道对应明细 -->
    <el-transfer filterable :filter-method="filterMethod" @change="changeData()" filter-placeholder="请输入用户名" :titles="['可选用户', '已选用户']" v-model="selectedData" :data="ALLdata"></el-transfer>
    <el-button class="transfer_btn" type="primary" @click="saveMapping()">保 存</el-button>
  </div>
</template>

<script>
export default {
  name: 'roleChannelUserMapping',
  data () {
    return {
      selectedId: '',
      filterData: [],
      ALLdata: [],
      selectedData: []
    }
  },
  created () {},
  mounted () {
    // this.getList()
  },
  methods: {
    // 获取渠道列表 -- 加管理员
    getList () {
      this.filterData = []
      this.$http.get(this.API.roleChannelList).then(res => {
        // console.log(res)
        let data = res.data
        if (data.code === 200) {
          let arr = data.data
          let filterData = []
          arr.forEach(ele => {
            // if (ele.channelId === null) {
            //   filterData.push({
            //     label: ele.roleName,
            //     value: ele.id
            //   })
            // } else {
            filterData.push({
              label: ele.roleName,
              value: ele.id + '-' + ele.channelId
            })
            // }
          })
          this.filterData = filterData
        } else {
          this.filterData = []
          this.$message.error('接口调用失败！')
        }
        // console.log(this.data)
      })
    },
    // 筛选角色对应用户
    search () {
      this.ALLdata = []
      this.selectedData = []
      // 角色ID
      let roleId = this.selectedId.split('-')[0]
      // console.log(roleId)
      if (roleId === '059F5F2642EE4667A01FA87BBF7431E5' || roleId === '08B3CC4EB39340A1A01F001947F046A6') {
        this.$http.get(this.API.queryAssociatedUserByRoleId, { params: { roleId: roleId } }).then(res => {
          // console.log(res)
          let data = res.data
          if (data.code === 200) {
            let ALLdata = []
            let selectedData = []
            // 选中用户
            let associatedUser = data.data.associatedUser
            // 全部用户
            let userInfos = data.data.userInfos
            if (userInfos.length > 0) {
              userInfos.forEach((ele, index) => {
                ALLdata.push({
                  key: ele.id,
                  label: ele.userName
                })
              })
            }
            if (associatedUser != null) {
              associatedUser.forEach((ele, index) => {
                selectedData.push(ele.id)
              })
            }
            this.ALLdata = ALLdata
            this.selectedData = selectedData
            // console.log(this.selectedData)
          }
        })
      } else {
        let channelId = this.selectedId.split('-')[1]
        this.$http.get(this.API.queryAssociatedUser, { params: { channelId: channelId, roleId: roleId } }).then(res => {
          // console.log(res)
          let data = res.data
          if (data.code === 200) {
            let ALLdata = []
            let selectedData = []
            // 选中用户
            let associatedUser = data.data.associatedUser
            // 全部用户
            let userInfos = data.data.userInfos
            if (userInfos.length > 0) {
              userInfos.forEach((ele, index) => {
                ALLdata.push({
                  key: ele.id,
                  label: ele.userName
                })
              })
            }
            if (associatedUser != null) {
              associatedUser.forEach((ele, index) => {
                selectedData.push(ele.id)
              })
            }
            this.ALLdata = ALLdata
            this.selectedData = selectedData
            // console.log(this.selectedData)
          }
        })
      }
    },
    // 保存角色渠道与用户关系
    saveMapping () {
      // console.log(this.filterData)
      let mapping = {}
      let associatedUser = []
      // 选中的用户id
      let selectedData = this.selectedData
      if (selectedData.length > 0) {
        selectedData.forEach((ele, index) => {
          associatedUser.push({
            id: ele
          })
        })
      }

      let roleId = this.selectedId.split('-')[0]
      let channelId = this.selectedId.split('-')[1]
      // roleID和channelId
      mapping.id = roleId
      mapping.channelId = channelId === 'null' ? null : channelId
      // 选中的用户id
      mapping.associatedUser = associatedUser
      this.$http.post(this.API.roleUserMappingSave, mapping).then(res => {
        // console.log(res)
        let data = res.data
        if (data.code === 200) {
          this.$message.success('修改关系成功！')
        } else {
          this.$message.error('接口调用失败！')
        }
      })
    },
    // 搜索用户
    filterMethod (query, item) {
      return item.label.indexOf(query) > -1
    },
    // 筛选发生变化
    changeData () {
      // console.log(this.selectedData)
    }
  }
}
</script>

<style lang="less" scoped>

</style>
